import { parse } from 'date-fns';
import { TimeFormatOptions } from 'shared/types/date-format-options';

import { isValidTime } from './is-valid-time';

// Null when the input is not a clock time in the user's format, so callers can flag the field.
export const parseTimeToMsOfDay = (
  value: string,
  timeFormat: TimeFormatOptions,
): number | null => {
  if (!isValidTime(value, timeFormat)) {
    return null;
  }

  const date = parse(value, timeFormat, new Date());

  // The format regex is looser than date-fns' parser (e.g. it admits double spacing
  // before AM/PM), so a value can validate and still parse to an invalid date.
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return (date.getHours() * 60 + date.getMinutes()) * 60 * 1000;
};
